import React from 'react';
import ReactLoading from 'react-loading';
import { useModal } from '../../hooks/Modal';

export const ModalLoading = () => {
  const { Modal } = useModal();

  return (
    <Modal transparent preventClose>
      <ReactLoading type="spin" color="#fff" />
    </Modal>
  );
};
